// return type status
export enum RETURN_TYPE {
  IFRAME = 'iframe',
  REDIRECT = 'redirect',
  INSTANT_QUOTING = 'instantQuoting',
}
export const returnTypeOptions = Object.values(RETURN_TYPE)
export type ReturnType = (typeof returnTypeOptions)[number]
export const returnTypeMap = {
  [RETURN_TYPE.IFRAME]: 'Iframe',
  [RETURN_TYPE.REDIRECT]: 'Redirect',
  [RETURN_TYPE.INSTANT_QUOTING]: 'Instant Quoting',
}
